import AccountLayout from '../../../components/layout/account-layout'
import { useState } from 'react'
import UpdateAddressModal from '../../../components/common/modal/modal-address'
import AddressBox from './address-box'
import { useUser } from '../../../common/hooks/auth/useUser'
import { AddressDTO, AddressDTOVerificationStatusEnum } from '@ringo/shared'
import { useTranslation } from '../../../useTranslation'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMasterDataApi } from '../../../common/api-context'
import { useQueryWithLoader } from '../../../components/loader/useQueryWithLoader'

const Addresses = () => {
    const [showAddressModal, setShowAddressModal] = useState(false)
    const { user } = useUser()
    const { t } = useTranslation()
    const masterDataApi = useMasterDataApi()

    const { data: masterData } = useQueryWithLoader('getAllMasterData', ['getAllMasterData'], async () => {
        return (await masterDataApi.getAllMasterData()).data
    })

    // Default selected living address
    const defaultAddress = user?.addresses?.filter((address) => address.defaultAddress)[0]

    // Other living addresses
    const otherAddresses = user?.addresses?.filter((address) => !address.defaultAddress)

    return (
        <AccountLayout>
            <UpdateAddressModal open={showAddressModal} onClose={() => setShowAddressModal(false)} />
            <h2 className="font-bold text-xl text-left mb-9 leading-none max-tablet:mb-8 max-tablet:text-base">{t('myAccount.addresses.standardAddresses')}</h2>
            <div className="grid grid-cols-2 gap-[12px]">
                {masterData && (
                    <AddressBox
                        address={
                            {
                                ...masterData.defaultData,
                                defaultAddress: false,
                            } as AddressDTO
                        }
                        pendingMasterAddressChange={masterData.approvalDto?.type === 'MASTER_DATA_CHANGE' && masterData.approvalDto?.status === 'NEW'}
                    />
                )}
                {defaultAddress && <AddressBox address={defaultAddress} />}
            </div>

            {otherAddresses?.length ? (
                <>
                    <h2 className="font-bold text-xl text-left mt-8 leading-none max-tablet:mt-8 max-tablet:text-base">
                        {t('myAccount.addresses.otherAddresses')}
                    </h2>
                    <div className="flex mt-2.5 mb-9 max-tablet:mb-8 max-tablet:mt-2">
                        <FontAwesomeIcon icon={['fas', 'circle-info']} className="text-custom_blue text-sm pr-2 align-middle mt-[3px]" />
                        <p className="text-base text-black font-light text-left max-tablet:text-sm">
                            {t('myAccount.addresses.theStandardAddressIsAutomaticallyUsed')}
                        </p>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                        {otherAddresses.map((address) => (
                            <AddressBox
                                address={address}
                                key={address.id}
                                pendingLivingAddressChange={address.verificationStatus === AddressDTOVerificationStatusEnum.InProgress}
                            />
                        ))}
                    </div>
                </>
            ) : (
                ''
            )}
        </AccountLayout>
    )
}

export default Addresses
